// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__yq4vH","icon":"Loader_icon__Z6THk","loader-animation":"Loader_loader-animation__lpGN0"};